import {HttpHandler} from "../../../utils/handler/HttpHandler";

export class InstructionService {
    constructor() {
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral/instruction');
    }

    saveSettlementFolios(params) {
        return this.axiosInstance({
            url: '/loan/' + params.loanId,
            method: 'post',
            data: {
                folioList: params.folioList
            }
        }).then(res => res);
    }

}